var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cb2e40",
    d: "M30 24H0V12h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1334a3",
    d: "M30 12H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 24V0l15 12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4d24b",
    d: "M7.86 11.63a2 2 0 0 0-.29-.68l1.44-1.02L9 9l-.93-.01-1.02 1.44a2 2 0 0 0-.68-.29l.3-1.49L6 8l-.67.65.3 1.5q-.38.06-.68.28L3.93 8.99 3 9l-.01.93 1.43 1.02q-.2.31-.28.68l-1.49-.3L2 12l.65.67 1.5-.3q.07.38.27.68L3 14.07V15l.93.01 1.02-1.44q.3.21.68.29l-.3 1.49L6 16l.67-.65-.3-1.5q.38-.07.68-.28l1.02 1.44L9 15l.01-.93-1.43-1.02q.2-.31.28-.68l1.49.3L10 12l-.65-.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/philippines.7667c759f8d687ce0d62f3c09fa163f9.svg";
export { ForwardRef as ReactComponent };